export const ANOUNCEMENT_TEXT =
  'Buy Worth ₹799/- and get Dry fruit bars Celebration pack FREE! Use Code: SHARK';

export const BRAND_LOGO = `https://cdn.shopify.com/s/files/1/0569/6867/5527/files/logo-happilo_180x.jpg?v=1676963092`;

const itemData = [
  {
    img: 'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/1v2_bf9e06f6-cd22-4209-a932-310a869534c0_720x.png?v=1632846581',
    title: 'Breakfast',
    author: '@bkristastucchio',
  },
  {
    img: 'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/back_fba9f5e6-686e-4e5b-aad9-31fffe66be68_900x.png?v=1632846581',
    title: 'Burger',
    author: '@rollelflex_graphy726',
  },
  {
    img: 'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/4v2_8e1bdd96-edf1-4662-9059-9ff3bb5575da_900x.jpg?v=1632846580',
    title: 'Camera',
    author: '@helloimnik',
  },
  {
    img: 'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/3_ff429d5d-d39f-4917-8288-6c2ed49a4b24_900x.jpg?v=1632846582',
    title: 'Coffee',
    author: '@nolanissac',
  },
  {
    img: 'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/5_145bf845-995e-4039-b52a-3cd15e6ec359_900x.jpg?v=1632846582',
    title: 'Hats',
    author: '@hjrc33',
  },
  {
    img: 'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/6_46cf0eb5-4ca8-42b6-854d-951ae338df56_900x.jpg?v=1632846582',
    title: 'Honey',
    author: '@arwinneil',
  },
  {
    img: 'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/7_a82ecf2c-2e9f-4983-840e-2821633c1007_900x.jpg?v=1632846581',
    title: 'Basketball',
    author: '@tjdragotta',
  },
  {
    img: 'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/packof2_3bd63f6e-ef0b-49d0-932f-37e8441b0d21_900x.jpg?v=1632846670',
    title: 'Fern',
    author: '@katie_wasserman',
  },
  {
    img: 'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/packof5_48baaae3-0970-4b46-849c-4f770d758e14_900x.jpg?v=1632846698',
    title: 'Mushrooms',
    author: '@silverdalex',
  },
  {
    img: 'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/1v2_8fa71dc0-6ea4-4663-8967-c6049ad5da62_900x.png?v=1632846639',
    title: 'Tomato basil',
    author: '@shelleypauls',
  },
  {
    img: 'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/almondspackof4_900x.jpg?v=1679307809',
    title: 'Sea star',
    author: '@peterlaster',
  },
  {
    img: 'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/610wodrIz_L._SL1000_39113a24-b7e9-4a06-bd17-88cd4bc8e520_900x.jpg?v=1679307809',
    title: 'Bike',
    author: '@southside_customs',
  },
  {
    img: 'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/packof2_cd522605-0e54-483a-b6bf-99c5cc6618d9_900x.jpg?v=1679307623',
    title: 'Bike',
    author: '@southside_customs',
  },
];

export const COLLECIONS = [
  {
    collection_name: 'bars',
    product_title: 'DRY FRUIT BARS',
    product_img:
      'https://cdn.shopify.com/s/files/1/0569/6867/5527/files/bar-collection.jpg?v=1677231033',
  },
  {
    collection_name: 'peanut-butter',
    product_title: 'PENUT BUTTER',
    product_img:
      'https://cdn.shopify.com/s/files/1/0569/6867/5527/files/peanut-butter-collection.jpg?v=1677231033',
  },
  {
    collection_name: 'chocolate-spreads',
    product_title: 'SPREADS',
    product_img:
      'https://cdn.shopify.com/s/files/1/0569/6867/5527/files/spreads-collection.jpg?v=1677231033',
  },
  {
    collection_name: 'barfi-brittles',
    product_title: 'BRILE & BARFI',
    product_img:
      '	https://cdn.shopify.com/s/files/1/0569/6867/5527/files/barfi-collection.jpg?v=1677231032',
  },
  {
    collection_name: 'snacks',
    product_title: 'PARTY SNACKS',
    product_img:
      'https://cdn.shopify.com/s/files/1/0569/6867/5527/files/snacks-collection.jpg?v=1677231033',
  },
  {
    collection_name: 'chocolate-spreads',
    product_title: 'SPREADS',
    product_img:
      'https://cdn.shopify.com/s/files/1/0569/6867/5527/files/spreads-collection.jpg?v=1677231033',
  },
  {
    collection_name: 'barfi-brittles',
    product_title: 'BRILE & BARFI',
    product_img:
      '	https://cdn.shopify.com/s/files/1/0569/6867/5527/files/barfi-collection.jpg?v=1677231032',
  },
  {
    collection_name: 'snacks',
    product_title: 'PARTY SNACKS',
    product_img:
      'https://cdn.shopify.com/s/files/1/0569/6867/5527/files/snacks-collection.jpg?v=1677231033',
  },
];
export const OTHER_PRODUCTS = [
  {
    product_id: 1,
    product_label: 'Trending',
    product_title: 'ADD TO CART',
    prooduct_customer_rating: 4.2,
    product_selling_price: '112.00',
    parent_collection: 'bars',
    sub_collection: [
      { id: 1, type: 'Corporate gifts' },
      { id: 2, type: 'Dry fruit bar' },
      { id: 3, type: 'Occasions gift' },
      { id: 4, type: 'Bars' },
      { id: 5, type: 'Rose' },
    ],
    avilability: 'In Stock',
    available_quantity: [
      { id: 1, quantity_type: '1 kg' },
      { id: 2, quantity_type: '2 kg (Pack of 2)' },
      { id: 3, quantity_type: '500 g' },
    ],
    vendor: 'Happilo Private Limited',
    product_img:
      'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/1v2_bf9e06f6-cd22-4209-a932-310a869534c0_720x.png?v=1632846581',

    product_sub_images: itemData,

    short_discription: 'Happilio 100% Natural Premium California Almonds',

    reasons_to_buy: [
      {
        id: 1,
        reason_title: 'Sourced from California',
        reason:
          'Happilo California almonds are handpicked from premium almond trees in California that are then packaged into a resealable bag to maintain freshness and crunch.',
      },
      {
        id: 1,
        reason_title: 'Sourced from California',
        reason:
          'Happilo California almonds are handpicked from premium almond trees in California that are then packaged into a resealable bag to maintain freshness and crunch.',
      },
      {
        id: 1,
        reason_title: 'Sourced from California',
        reason:
          'Happilo California almonds are handpicked from premium almond trees in California that are then packaged into a resealable bag to maintain freshness and crunch.',
      },
      {
        id: 1,
        reason_title: 'Sourced from California',
        reason:
          'Happilo California almonds are handpicked from premium almond trees in California that are then packaged into a resealable bag to maintain freshness and crunch.',
      },
      {
        id: 1,
        reason_title: 'Sourced from California',
        reason:
          'Happilo California almonds are handpicked from premium almond trees in California that are then packaged into a resealable bag to maintain freshness and crunch.',
      },
      {
        id: 1,
        reason_title: 'Sourced from California',
        reason:
          'Happilo California almonds are handpicked from premium almond trees in California that are then packaged into a resealable bag to maintain freshness and crunch.',
      },
      {
        id: 1,
        reason_title: 'Sourced from California',
        reason:
          'Happilo California almonds are handpicked from premium almond trees in California that are then packaged into a resealable bag to maintain freshness and crunch.',
      },
      {
        id: 1,
        reason_title: 'Sourced from California',
        reason:
          'Happilo California almonds are handpicked from premium almond trees in California that are then packaged into a resealable bag to maintain freshness and crunch.',
      },
      {
        id: 1,
        reason_title: 'Sourced from California',
        reason:
          'Happilo California almonds are handpicked from premium almond trees in California that are then packaged into a resealable bag to maintain freshness and crunch.',
      },
      {
        id: 1,
        reason_title: 'Sourced from California',
        reason:
          'Happilo California almonds are handpicked from premium almond trees in California that are then packaged into a resealable bag to maintain freshness and crunch.',
      },
    ],
  },
  {
    product_id: 2,
    product_label: 'Best Seller',
    product_title: 'ADD TO CART',
    product_selling_price: '135.00',
    parent_collection: 'bars',
    sub_collection: [
      { id: 1, type: 'Corporate gifts' },
      { id: 2, type: 'Dry fruit bar' },
      { id: 3, type: 'Occasions gift' },
      { id: 4, type: 'Bars' },
      { id: 5, type: 'Rose' },
    ],
    prooduct_customer_rating: 4.3,
    short_discription: 'Happilio 100% Natural Premium California Almonds',
    vendor: 'Happilo Private Limited',
    available_quantity: [
      { id: 1, quantity_type: '1 kg' },
      { id: 2, quantity_type: '2 kg (Pack of 2)' },
      { id: 3, quantity_type: '500 g' },
    ],
    avilability: 'In Stock',
    product_img:
      'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/Front_720x.png?v=1632847785',
    product_sub_images: itemData,
  },
  {
    product_id: 3,
    product_label: 'Popular',
    product_title: 'ADD TO CART',
    product_selling_price: '187.00',
    parent_collection: 'bars',
    sub_collection: [
      { id: 1, type: 'Corporate gifts' },
      { id: 2, type: 'Dry fruit bar' },
      { id: 3, type: 'Occasions gift' },
      { id: 4, type: 'Bars' },
      { id: 5, type: 'Rose' },
    ],
    prooduct_customer_rating: 3.4,
    short_discription: 'Happilio 100% Natural Premium California Almonds',
    vendor: 'Happilo Private Limited',
    available_quantity: [
      { id: 1, quantity_type: '1 kg' },
      { id: 2, quantity_type: '2 kg (Pack of 2)' },
      { id: 3, quantity_type: '500 g' },
    ],
    avilability: 'In Stock',
    product_img:
      'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/Front_5ce707ac-7eef-4eb5-a97e-78fe2a1f9870_720x.png?v=1632913711',
    product_sub_images: itemData,
  },
  {
    product_id: 4,
    product_label: 'Must Try',
    product_title: 'ADD TO CART',
    parent_collection: 'bars',
    sub_collection: [
      { id: 1, type: 'Corporate gifts' },
      { id: 2, type: 'Dry fruit bar' },
      { id: 3, type: 'Occasions gift' },
      { id: 4, type: 'Bars' },
      { id: 5, type: 'Rose' },
    ],
    product_selling_price: '205.00',
    prooduct_customer_rating: 5,
    available_quantity: [
      { id: 1, quantity_type: '1 kg' },
      { id: 2, quantity_type: '2 kg (Pack of 2)' },
      { id: 3, quantity_type: '500 g' },
    ],
    avilability: 'Out of Stock',
    short_discription: 'Happilio 100% Natural Premium California Almonds',
    vendor: 'Happilo Private Limited',
    product_img:
      'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/1v2_31f6f791-8f26-464d-b873-977135c3b410_720x.png?v=1632913885',
    product_sub_images: itemData,
  },
  {
    product_id: 5,
    product_label: 'Trending',
    product_title: 'ADD TO CART',
    product_selling_price: '304.00',
    parent_collection: 'bars',
    available_quantity: [
      { id: 1, quantity_type: '1 kg' },
      { id: 2, quantity_type: '2 kg (Pack of 2)' },
      { id: 3, quantity_type: '500 g' },
    ],
    sub_collection: [
      { id: 1, type: 'Corporate gifts' },
      { id: 2, type: 'Dry fruit bar' },
      { id: 3, type: 'Occasions gift' },
      { id: 4, type: 'Bars' },
      { id: 5, type: 'Rose' },
    ],
    vendor: 'Happilo Private Limited',
    prooduct_customer_rating: 2.1,
    avilability: 'Out of Stock',
    short_discription: 'Happilio 100% Natural Premium California Almonds',
    product_img:
      'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/1v2_ae80c043-716c-49c4-ad1c-8d92296ef3ee_720x.png?v=1632908409',
    product_sub_images: itemData,
  },
  {
    product_id: 3,
    product_label: 'Popular',
    product_title: 'ADD TO CART',
    product_selling_price: '795.00',
    parent_collection: 'bars',
    sub_collection: [
      { id: 1, type: 'Corporate gifts' },
      { id: 2, type: 'Dry fruit bar' },
      { id: 3, type: 'Occasions gift' },
      { id: 4, type: 'Bars' },
      { id: 5, type: 'Rose' },
    ],
    avilability: 'In Stock',
    available_quantity: [
      { id: 1, quantity_type: '1 kg' },
      { id: 2, quantity_type: '2 kg (Pack of 2)' },
      { id: 3, quantity_type: '500 g' },
    ],
    vendor: 'INT Dry Fruit PVT Ltd.',
    prooduct_customer_rating: 3.4,
    short_discription: 'Happilio 100% Natural Premium California Almonds',
    product_img:
      'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/Front_5ce707ac-7eef-4eb5-a97e-78fe2a1f9870_720x.png?v=1632913711',
    product_sub_images: itemData,
  },
  {
    product_id: 4,
    product_label: 'Must Try',
    product_title: 'ADD TO CART',
    available_quantity: [
      { id: 1, quantity_type: '1 kg' },
      { id: 2, quantity_type: '2 kg (Pack of 2)' },
      { id: 3, quantity_type: '500 g' },
    ],
    parent_collection: 'chocolate_spreads',
    sub_collection: [
      { id: 1, type: 'Corporate gifts' },
      { id: 2, type: 'Dry fruit bar' },
      { id: 3, type: 'Occasions gift' },
      { id: 4, type: 'Bars' },
      { id: 5, type: 'Rose' },
    ],
    avilability: 'In Stock',
    product_selling_price: '445.00',
    prooduct_customer_rating: 5,
    short_discription: 'Happilio 100% Natural Premium California Almonds',
    vendor: 'Happilo Private Limited',
    product_img:
      'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/1v2_31f6f791-8f26-464d-b873-977135c3b410_720x.png?v=1632913885',
    product_sub_images: itemData,
  },
  {
    product_id: 5,
    product_label: 'Trending',
    product_title: 'ADD TO CART',
    parent_collection: 'peanut_butter',
    sub_collection: [
      { id: 1, type: 'Corporate gifts' },
      { id: 2, type: 'Dry fruit bar' },
      { id: 3, type: 'Occasions gift' },
      { id: 4, type: 'Bars' },
      { id: 5, type: 'Rose' },
    ],
    avilability: 'In Stock',
    vendor: 'Happilo Private Limited',
    product_selling_price: '285.00',
    prooduct_customer_rating: 2.1,
    available_quantity: [
      { id: 1, quantity_type: '1 kg' },
      { id: 2, quantity_type: '2 kg (Pack of 2)' },
      { id: 3, quantity_type: '500 g' },
    ],

    short_discription: 'Happilio 100% Natural Premium California Almonds',
    product_img:
      'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/1v2_ae80c043-716c-49c4-ad1c-8d92296ef3ee_720x.png?v=1632908409',
    product_sub_images: itemData,
  },
];

export const SHOPING_BANNER =
  'https://d3nez31vakvhqn.cloudfront.net/Happilo/Up-Dynamic+banner-+sid.png';

export const SHOPING_BANNER_PRODUCT =
  'https://cdn.shopify.com/s/files/1/0569/6867/5527/products/1v2_bf9e06f6-cd22-4209-a932-310a869534c0.png?v=1632846581';

export const CAROUSEL_IMAGE = [
  {
    url: 'https://cdn.shopify.com/s/files/1/0569/6867/5527/files/Announcement_IPL_Banner_Desktop_1lakh_Ticket_Desktop_1_2_1728x.jpg?v=1680279573',
  },
  {
    url: 'https://cdn.shopify.com/s/files/1/0569/6867/5527/files/Main_IPL_Banner_Desktop_IPL_Main_Banner_DESKTOP_1_1728x.jpg?v=1680245764',
  },
  {
    url: 'https://cdn.shopify.com/s/files/1/0569/6867/5527/files/Marvel-desk_1728x.png?v=1675406416',
  },
  {
    url: 'https://cdn.shopify.com/s/files/1/0569/6867/5527/files/NEWLY_UPDATED_ipl_desktop_banner_2260x.jpg?v=1679574409',
  },
  {
    url: 'https://cdn.shopify.com/s/files/1/0569/6867/5527/collections/Happilo_Website_Banners_11112022_Chocolate_Spread_1512X515_88a2608e-f6e5-49bd-a547-c85270cdbdf3.jpg?v=1675085062',
  },
];

export const topFilms = [
  { title: 'The Shawshank Redemption', year: 1994 },
  { title: 'The Godfather', year: 1972 },
  { title: 'The Godfather: Part II', year: 1974 },
  { title: 'The Dark Knight', year: 2008 },
  { title: '12 Angry Men', year: 1957 },
  { title: "Schindler's List", year: 1993 },
  { title: 'Pulp Fiction', year: 1994 },
  {
    title: 'The Lord of the Rings: The Return of the King',
    year: 2003,
  },
  { title: 'The Good, the Bad and the Ugly', year: 1966 },
  { title: 'Fight Club', year: 1999 },
  {
    title: 'The Lord of the Rings: The Fellowship of the Ring',
    year: 2001,
  },
  {
    title: 'Star Wars: Episode V - The Empire Strikes Back',
    year: 1980,
  },
  { title: 'Forrest Gump', year: 1994 },
  { title: 'Inception', year: 2010 },
  {
    title: 'The Lord of the Rings: The Two Towers',
    year: 2002,
  },
  { title: "One Flew Over the Cuckoo's Nest", year: 1975 },
  { title: 'Goodfellas', year: 1990 },
  { title: 'The Matrix', year: 1999 },
  { title: 'Seven Samurai', year: 1954 },
  {
    title: 'Star Wars: Episode IV - A New Hope',
    year: 1977,
  },
  { title: 'City of God', year: 2002 },
  { title: 'Se7en', year: 1995 },
  { title: 'The Silence of the Lambs', year: 1991 },
  { title: "It's a Wonderful Life", year: 1946 },
  { title: 'Life Is Beautiful', year: 1997 },
  { title: 'The Usual Suspects', year: 1995 },
  { title: 'Léon: The Professional', year: 1994 },
  { title: 'Spirited Away', year: 2001 },
  { title: 'Saving Private Ryan', year: 1998 },
  { title: 'Once Upon a Time in the West', year: 1968 },
  { title: 'American History X', year: 1998 },
  { title: 'Interstellar', year: 2014 },
];

export const PRODUCT_LABEL_BACKGROUND = {
  Trending: '#FFA500',
  Popular: '#A020F0',
  'Best Seller': '#0000FF',
  'Must Try': '#00523b',
};

export const FOOTER_TEXT = {
  COPYRIGHT_MESSAGE:
    '© 2023 Happilo_Clone PVT. LTD. All Rights Reserved.(Deepak & Vishal)',
};

export const JOURNEY_TEXT = {
  JOURNEY_MESSAGE:
    'Happilo is a health food brand founded in the year 2016, headquartered in Bengaluru. Happilo bring to you an exclusive range of Nuts, dried fruits, seeds, Dry Roasted snacks, trial mixes, festive gift hampers and more. With a wide variety products that cater to every taste and age group, our best sellers have found their way into the homes and hearts of many households. The product innovations over the years and production volumes were made possible with our automated manufacturing unit at yeshwantpur – Bengaluru. Gourmet brand Happilo is available across all leading Modern Retail and General Trades. and is also one of the most popular FMCG brands searched for on e-commerce sites.',
};

export const availableSizes = [
  { id: 1, quantity: '200 g', price: 203 },
  { id: 2, quantity: '200 g (Pack of 2)', price: 399 },
  { id: 3, quantity: '200 g (Pack of 5)', price: 899.5 },
  { id: 4, quantity: '500 g', price: 820.5 },
  {
    id: 5,
    quantity: '500 g (Pack of 2)',
    price: 449,
  },
  {
    id: 6,
    quantity: '1 kg',
    price: 799,
  },
  {
    id: 7,
    quantity: '1 kg (Pack of 2)',
    price: 1550,
  },
];
